import { BrowserRouter } from "react-router-dom";
import { ParentModeProvider } from "../parent/ParentModeProvider";
import { ErrorBoundary } from "./ErrorBoundary";
import { AppRoutes } from "./routes";

export function App() {
  return (
    <ErrorBoundary>
      <ParentModeProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </ParentModeProvider>
    </ErrorBoundary>
  );
}
